export function formatTodayHours(scheduleData) {
    if (!scheduleData) return 'N/A';

    let hoursObj = scheduleData;
    if (typeof scheduleData === 'string') {
        try { hoursObj = JSON.parse(scheduleData); } catch (e) { return 'N/A'; }
    }

    // Legacy Fallback (Old data format)
    if (hoursObj.open && hoursObj.close) {
        return `${hoursObj.open} - ${hoursObj.close}`;
    }

    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const todayStr = days[new Date().getDay()];
    const todaySchedule = hoursObj[todayStr];

    if (!todaySchedule) return 'N/A';
    if (todaySchedule.isClosed) return 'Closed Today';
    
    if (todaySchedule.shifts && todaySchedule.shifts.length > 0) {
        return todaySchedule.shifts.map(s => `${s.startTime} - ${s.endTime}`).join(', ');
    }

    return 'N/A';
}
